import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CentralMetadataService } from 'app/services/central-metadata.service';
import { ContactService } from 'app/services/contactService';
import { DataService } from 'app/services/data.service';
import { TeamService } from 'app/services/team.service';
import { UserService } from 'app/services/user.service';
import { FormBuilder } from '@atefhashem/eforms';
import { ToastService } from 'ng-uikit-pro-standard';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-metadata-builder',
  templateUrl: './metadata-builder.component.html',
  styleUrls: ['./metadata-builder.component.scss']
})
export class MetadataBuilderComponent implements OnInit {

  isLoadingForm: boolean = true;
  frmBuilder: FormBuilder;
  
  constructor(public centralMetadataService: CentralMetadataService, private router: Router,
              private toastService: ToastService, private userService: UserService, 
              private teamService: TeamService, private contactService: ContactService,
              private dataService: DataService) { }

  ngOnInit(): void {
    document.getElementById('metadata_builder').innerHTML = "";
    this.isLoadingForm = true;
    this.centralMetadataService.getForm().pipe(finalize(() => {
      this.isLoadingForm = false;
    })).subscribe((form) => {
       this.displayForm(form);
    }, () => {
      /** @todo handle error */
      this.toastService.error('Error getting metadata!');
    });
  }

  displayForm(form) {
    document.getElementById('metadata_builder').innerHTML = "";
    this.frmBuilder = new FormBuilder(document.getElementById('metadata_builder'), form, {
      noDefaultSubmitButton : true,
      builder: {
        basic: false,
        advanced: false,
        data: false,
        layout: false,
        premium: false,
        custom: {
          title: 'Meta Fields',
          weight: 10,
          default: true,
          components: {
            textfield: true,
            textarea: true,
            number: true,
            select: {
              title: 'Dropdown',
              label: 'Dropdown',
              icon: 'caret-square-down',
              schema: {
                multiple: false,
                type: 'select'
              }
            },
            datadropdown: true,
            team: true,
            contact: true,
            email: true,
            url: true,
            user: true,
            phoneNumber: true,
            datetime: true,
            currency: true
          }
        }
      },
      editForm: {
        textfield: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'data',
            components: [
              {
                key: 'calculateValuePanel',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        textarea: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'data',
            components: [
              {
                key: 'calculateValuePanel',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        number: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'data',
            components: [
              {
                key: 'calculateValuePanel',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        select: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'multiple',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        datadropdown: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'multiple',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        email: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        url: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        phoneNumber: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        datetime: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        currency: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'data',
            components: [
              {
                key: 'calculateValuePanel',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }      
        ],
        user: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        team: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ],
        contact: [
          {
            key: 'display',
            components: [
              {
                key: 'hideLabel',
                ignore: true
              },
              {
                key: 'hidden',
                ignore: true
              },
              {
                key: 'clearOnHide',
                ignore: true
              },
              {
                key: 'disabled',
                ignore: true
              }
            ]
          },
          {
            key: 'validation',
            components: [
              {
                key: 'validate.required',
                ignore: true,
              }
            ]
          },
          {
            key: 'conditional',
            ignore: true
          }        
        ]
      },
      evalContext: {
        getDataFieldTermsObservable: (indexPattern: string, fieldKey: string, searchFilter: string = '') =>  {
          return this.dataService.getFieldTerms(indexPattern, fieldKey, searchFilter);
        },
        getDataRawSearchObservable: (indexPattern: string, body: any) => {
          return this.dataService.rawSearch(indexPattern, body);
        },
        getDataSQLQueryObservable: (query: string, format: string = 'json') => {
          return this.dataService.sqlQueryResults(query, format);
        },
        /** @note these do not work in external access yet */
        getUsersObservable: () => {
          return this.userService.getAll();
        },
        getTeamsObservable: () => {
          return this.teamService.getAll();
        },
        getContactsObservable: () => {
          return this.contactService.getAll();
        }
      }
    }); 
  }

  onSaveClick() {
    let schema = this.frmBuilder.instance.form;
    this.isLoadingForm = true;
    this.centralMetadataService.putForm(schema).pipe(finalize(() => {
      this.isLoadingForm = false;
    })).subscribe((form) => {
      this.toastService.success('Metadata Updated!');
      this.router.navigate(['/manage/metadata']);
    }, () => {
      /** @todo handle error */
      this.toastService.error('Error updating metadata!');
    });
  }
}
